import validate from 'validate.js'

validate.validators.isCpf = (value, options) => {
  if (value == "" || value == null)
    return null;

  if((value = value.replace(/[^\d]/g,"")).length != 11)
    return options.message;

  if (value == "00000000000")
    return options.message;
    
  let r;
  let s = 0;   

  for (let i=1; i<=9; i++)
    s = s + parseInt(value[i-1]) * (11 - i); 

  r = (s * 10) % 11;

  if ((r == 10) || (r == 11)) 
    r = 0;

  if (r != parseInt(value[9]))
    return options.message;

  s = 0;

  for (let i = 1; i <= 10; i++)
    s = s + parseInt(value[i-1]) * (12 - i);

  r = (s * 10) % 11;

  if ((r == 10) || (r == 11)) 
    r = 0;

  if (r != parseInt(value[10]))
    return options.message;

  return null;
};

export const constraints = {
    nroCep: {
        length: {
            minimum: 8,
            maximum: 8,
            message: "inválido."
        }
    },
    nroCpf: {
        isCpf: {
          message: "é inválido."
        },
        length: {
            minimum: 11,
            maximum: 11,
            message: "inválido."
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-login/pbm-login.constraints.js